import React, {Fragment, useContext} from "react";
import {TranslateContext} from "../../../../../context/TranslateContext.jsx";
import ModalConfirm from "../../../../../components/ModalConfirm.jsx";
import CaricamentoInCorso from "../../../../../components/CaricamentoInCorso.jsx";
import NsButtonActionsGroup from "../../../../../components/buttons/NsButtonActionsGroup.jsx";
import NsButtonAction from "../../../../../components/buttons/NsButtonAction.jsx";
import {useTabellaBatch} from "./useTabellaBatch.jsx";
import ModalMsg from "../../../../../components/ModalMsg";
import DataTableCmms from "../../../../../components/tabelle/NsDataTable";

export default function TabellaBatch() {

    const {
        loadingData,
        batch,
        batchSel,
        setBatchSel,
        showConfirmDelete,
        setShowConfirmDelete,
        deleteBatch,
        modalMsg,
        closeModal,
        show,
        funzioneFiltro,
    } = useTabellaBatch();

    const {traduci} = useContext(TranslateContext);

    return (
        <Fragment>
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <ModalConfirm
                show={showConfirmDelete}
                handleClose={() => setShowConfirmDelete(false)}
                handleOk={deleteBatch}
                testo={traduci("Sicuro di voler rimuovere il batch: ") + (batchSel && batchSel.codice) + "?"}/>
            {
                loadingData ? (
                    <CaricamentoInCorso/>
                ) : (
                    <DataTableCmms
                        data={batch}
                        columns={[
                            {
                                name: 'Codice',
                                selector: row => row.codice,
                                sortable: true,
                            },
                            {
                                name: 'Descrizione',
                                selector: row => row.descrizione,
                                sortable: true,
                            },
                            {
                                name: 'Endpoint',
                                selector: row => row.endpoint,
                                sortable: true,
                            },
                            {
                                name: '',
                                selector: row => <Fragment>
                                    <NsButtonActionsGroup>
                                        <li>
                                            <NsButtonAction
                                                label={"Modifica"}
                                                icona={"fas fa-pen"}
                                                href={`/upd-batch/${row.id_batch}`}
                                            />
                                        </li>
                                        <li>
                                            <NsButtonAction
                                                label={"Elimina"}
                                                icona={"fas fa-trash"}
                                                onClick={() => {
                                                    setBatchSel(row)
                                                    setShowConfirmDelete(true);
                                                }}
                                            />
                                        </li>
                                    </NsButtonActionsGroup>
                                </Fragment>,
                                sortable: false,
                                right: true,
                            }
                        ]}
                        funzioneFiltro={funzioneFiltro}
                    />
                )
            }
        </Fragment>
    );

}